import Badge from "@mui/material/Badge";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import AccountCircle from "@mui/icons-material/AccountCircle";
import GetIcon from "@/components/font-awesome-icon";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import config from "@/config";
import { generateImageUrlByName, returnURL } from "@/services/generic.methods";
import AvatarDefault from "@/components/avatar";
export const RightNavItems = [
  {
    id: 1,
    name: "switchTo",
    title: "SwitchTo",
    icon: <SyncAltIcon color="custom.header_text" />,
    haspopup: false,
    link: returnURL() + "home",
    redirect: true,
    showTooltip: true,
  },
  {
    id: 2,
    name: "settings",
    title: "Settings",
    link: "/crm/settings",
    icon: <SettingsOutlinedIcon color="custom.header_text" />,
    haspopup: false,
    showTooltip: true,
  },
  {
    id: 3,
    name: "notifications",
    title: "Notifications",
    showTooltip: true,
    icon: (count, animateBell) => (
      <Badge
        badgeContent={count}
        max={9}
        sx={{
          "& .MuiBadge-badge": {
            bgcolor: "var(--palette-orange_shade)",
          },
        }}
      >
        <NotificationsNoneOutlinedIcon
          className={animateBell}
          color="custom.header_text"
        />
      </Badge>
    ),
    haspopup: true,
  },
  {
    id: 4,
    name: "profile",
    title: "Profile",
    icon: (profile = {}) => {
      return (
        <AvatarDefault
          name={profile?.DisplayName}
          src={generateImageUrlByName(profile?.UserProfileImageBlobUrl)}
          // avatarClasses={onClick ? styles.profileImage : ""}
          avatarStyles={{
            width: 40,
            height: 40,
            fontSize: "1rem !important",
            color: "custom.header_text",
          }}
        />
      );
    },
    // <GetIcon
    //   color="primary"
    //   icon={faUser}
    //   iconClass="bg-primary profile-icon"
    // />

    haspopup: true,
  },
];
